import * as service from "../service";
import { store } from "../../store";

export type SponsorActivity = Record<string, any>;

/**
 * Fetch paginated sponsor activities (admin only).
 * Backend: GET /api/sponsor/getAllSponsorActivities
 */
export const GetAllSponsorActivitiesAPI = async (
  page: number = 1,
  status?: string,
): Promise<any> => {
  try {
    const admin = store.getState().auth.admin;
    let endpoint = `/api/sponsor/getAllSponsorActivities?user_id=${admin.id}&page=${page}`;
    if (status) {
      endpoint += `&status=${status}`;
    }
    const resp = await service.call("GET", endpoint);
    return resp;
  } catch (err) {
    console.error(`GetAllSponsorActivitiesAPI ${err}`);
    return { status: -1, resp: err };
  }
};